import type { QueryParamsDto } from "@mimber/schema"

const buildQueryParams = (params: QueryParamsDto): string => {
  const searchParams = new URLSearchParams()

  // Add filters: filters[email][contains]=john, filters[status][in][0]=A&filters[status][in][1]=B
  if (params.filters) {
    Object.entries(params.filters).forEach(([field, operators]) => {
      Object.entries(operators).forEach(([operator, value]) => {
        if (Array.isArray(value)) {
          value.forEach((item, index) => {
            searchParams.append(
              `filters[${field}][${operator}][${index}]`,
              String(item)
            )
          })
        } else {
          searchParams.append(`filters[${field}][${operator}]`, String(value))
        }
      })
    })
  }

  // Add sorts: sort[createdAt]=desc
  if (params.sort) {
    Object.entries(params.sort).forEach(([field, direction]) => {
      searchParams.append(`sort[${field}]`, direction)
    })
  }

  // Add pagination: pagination[page]=1&pagination[limit]=10
  if (params.page) searchParams.append("pagination[page]", String(params.page))
  if (params.limit)
    searchParams.append("pagination[limit]", String(params.limit))
  if (params.search) searchParams.append("search", params.search)

  return searchParams.toString()
}

export const buildQueryString = (
  endpoint: string,
  params?: QueryParamsDto
): string => {
  if (!params) return endpoint

  const queryString = buildQueryParams(params)
  return queryString ? `${endpoint}?${queryString}` : endpoint
}
